import React from "react";
import { isNil } from "ramda";
import { connect } from "react-redux";
import {
  saveNewModuleCardField,
  syncModuleCardField,
} from "manage-modules/redux/manageModulesActions";
import CheckboxSync from "components/CheckboxSync";
import styles from "manage-modules/components/card/ModuleSettingsTab.css";

const ModuleSettingsTab = ({
  fields,
  isNew,
  onSaveStatus,
  onSaveExcludeFromCatalog,
  onSaveInDplaCatalog,
  onSyncExcludeFromCatalog,
  onSyncStatus,
  onSyncInDplaCatalog,
  onSaveHideInPatronModuleList,
  onSyncHideInPatronModuleList,
  syncingFields,
}) => (
  <div className={styles.container}>
    <div className={styles.checkboxContainer}>
      <CheckboxSync
        checked={fields.status === "ACTIVE"}
        name="status"
        label="Active"
        onChange={isNew ? onSaveStatus : onSyncStatus}
        syncing={!isNil(syncingFields["status"])}
      />
      <CheckboxSync
        checked={fields.excludeFromCatalog}
        name="excludeFromCatalog"
        label="Exclude from catalog"
        onChange={isNew ? onSaveExcludeFromCatalog : onSyncExcludeFromCatalog}
        syncing={!isNil(syncingFields["excludeFromCatalog"])}
      />
      <CheckboxSync
        checked={fields.inDplaCatalog}
        name="inDplaCatalog"
        label="Include in DPLA Catalog"
        onChange={isNew ? onSaveInDplaCatalog : onSyncInDplaCatalog}
        syncing={!isNil(syncingFields["inDplaCatalog"])}
      />
      <CheckboxSync
        checked={fields.hideInPatronModuleList}
        name="hideInPatronModuleList"
        label="Hide in Patron Module List"
        onChange={
          isNew ? onSaveHideInPatronModuleList : onSyncHideInPatronModuleList
        }
        syncing={!isNil(syncingFields["hideInPatronModuleList"])}
      />
    </div>
  </div>
);

const mapStateToProps = state => {
  const { module, fields } = state.manageModules.moduleCard;
  const syncingFields = state.manageModules.syncingFields[module.id] || {};

  return {
    isNew: !module.id,
    fields,
    syncingFields,
  };
};

const mapDispatchToProps = dispatch => ({
  onSaveExcludeFromCatalog: value => {
    dispatch(saveNewModuleCardField("excludeFromCatalog", value));
  },
  onSaveStatus: value => {
    dispatch(saveNewModuleCardField("status", value ? "ACTIVE" : "DELETED"));
  },
  onSaveInDplaCatalog: value => {
    dispatch(saveNewModuleCardField("inDplaCatalog", value));
  },
  onSaveHideInPatronModuleList: value => {
    dispatch(saveNewModuleCardField("hideInPatronModuleList", value));
  },

  onSyncExcludeFromCatalog: value => {
    dispatch(syncModuleCardField("excludeFromCatalog", value));
  },
  onSyncStatus: value => {
    dispatch(syncModuleCardField("status", value ? "ACTIVE" : "DELETED"));
  },
  onSyncInDplaCatalog: value => {
    dispatch(syncModuleCardField("inDplaCatalog", value));
  },
  onSyncHideInPatronModuleList: value => {
    dispatch(syncModuleCardField("hideInPatronModuleList", value));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(ModuleSettingsTab);
